<template>
  <page :title="title">
    <div>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.selectionCriteria }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <message :messages="messages"></message>
                <form>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :items="branchList"
                          item-text="label"
                          item-value="value"
                          v-validate="'required'"
                          v-model="form.branch"
                          :label="labels.branch"
                          :error-messages="errors.collect('form.branch')"
                          data-vv-name="form.branch"
                          :data-vv-as="labels.branch"
                          :loading="loading"
                        >
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6></v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :items="funds"
                          item-text="label"
                          item-value="value"
                          v-validate="'required'"
                          v-model="form.fund"
                          :label="labels.fund"
                          :error-messages="errors.collect('form.fund')"
                          data-vv-name="form.fund"
                          :data-vv-as="labels.fund"
                          :loading="loading"
                        >
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :items="tranTypeList1"
                          item-text="label"
                          item-value="value"
                          v-validate="'required'"
                          v-model="form.tranType1"
                          :label="labels.tranType1"
                          :error-messages="errors.collect('form.tranType1')"
                          data-vv-name="form.tranType1"
                          :data-vv-as="labels.tranType1"
                          :loading="loading"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :items="docNoItems"
                          item-value="docNo"
                          item-text="docNo"
                          v-validate="'required'"
                          v-model="form.docNo"
                          :label="labels.docNo"
                          :error-messages="errors.collect('form.docNo')"
                          data-vv-name="form.docNo"
                          :data-vv-as="labels.docNo"
                          :loading="loading"
                          @change="updateRelatedFields"
                          clearable
                          @click:clear="clearRelatedFields"
                        >
                          <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                            <v-icon color="info" @click="openDocNoModal" v-text="'mdi-magnify'"></v-icon>
                          </v-slide-x-reverse-transition>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          disabled
                          :label="labels.name"
                          v-model="form.name"
                          :error-messages="errors.collect('form.name')"
                          data-vv-name="name"
                          :data-vv-as="labels.name"
                          :loading="loading"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          disabled
                          :label="labels.currency"
                          v-model="form.currency"
                          :error-messages="errors.collect('form.currency')"
                          data-vv-name="currency"
                          :data-vv-as="labels.currency"
                          :loading="loading"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          disabled
                          :label="labels.amount"
                          v-model="form.amount"
                          :error-messages="errors.collect('form.amount')"
                          data-vv-name="amount"
                          :data-vv-as="labels.amount"
                          :loading="loading"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </form>
              </v-card-text>
            </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-layout>
                    <v-flex xs12 row wrap>
              <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">{{ labels.cancel }}<v-icon dark right>mdi-cancel</v-icon></v-btn>
              <v-btn color="primary" @click.prevent="doSave">{{ labels.submit }}<v-icon dark right>mdi-arrow-right-bold-box</v-icon></v-btn>
            </v-flex>
        <v-dialog v-model="showUnRelClmDocHelpList" width="1280px">
          <UnRelClmDocHelpList
            @close="showUnRelClmDocHelpList = false"
            @assign-docNo="assignDocNo"
            :branch="form.branch"
            :fund="form.fund"
            :tranType1="form.tranType1"
          ></UnRelClmDocHelpList>
        </v-dialog>
      </v-container>
    </div>
  </page>
</template>
<script>
import { DEL_CLMUNREL_SEL_DATA } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { formatDisplayNumber } from '@/utils/number'
import claimUnrelDelMixin from '@/mixins/claim/claimUnrelDelMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import UnRelClmDocHelpList from '@/components/core/claimManagement/sideFunction/clmUnrelDel/UnRelClmDocHelpList'

export default {
  data() {
    return {
      title: 'Delete Unreleased Claims Transaction',
      showUnRelClmDocHelpList: false,
      labels: {
        branch: 'Branch',
        fund: 'Fund',
        tranType1: 'Tran Type (W/X/Y/Z)',
        docNo: 'Document No.',
        name: 'Name',
        currency: 'Currency',
        amount: 'Amount',
        cancel: 'Cancel',
        submit: 'Submit',
        selectionCriteria: 'Selection Criteria'
      },
      form: {
        branch: this.$store.state.token.userBranch,
        fund: '',
        tranType1: 'W',
        docNo: '',
        name: '',
        currency: '',
        amount: this.formatDisplayNumber(0)
      },
      funds: [],
      branches: [],
      docNoItems: [],
      amountcurrencies: [],
      clmPaytHdr: {},
      loading: false,
      TRUE: true,
      branchList: [],
      panel: [0]
    }
  },
  mounted() {
    this.doInit()
  },
  methods: {
    doCancel() {
      this.$router.push({ name: 'specialFuncClm' })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit(DEL_CLMUNREL_SEL_DATA, this.form)
          this.$router.push({ name: 'clmUnrelDelPayDet' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doInit() {
      this.loading = true
      this.getCommonDataListDropDown('funds')
      this.getBaseCurr('baseCurrency')
      this.getCommonDataListDropDown('amountcurrencies')
      this.getCommonDataListDropDown('branchList')
      this.loading = false
    },
    getDocNoItem() {
      for (let item of this.docNoItems) {
        if (item.docNo === this.form.docNo) {
          return item
        }
      }
      return {}
    },
    updateRelatedFields() {
      let item = this.getDocNoItem()
      this.form.name = item.name
      this.form.currency = item.curr
      this.form.amount = this.formatDisplayNumber(item.paytAmt)
    },
    clearRelatedFields() {
      this.form.docNo = ''
      this.form.name = ''
      this.form.currency = ''
      this.form.amount = this.formatDisplayNumber(0)
    },
    async updateDocNoList() {
      this.doFetchUnRelClmDoc(this.form.branch, this.form.fund, this.form.tranType1)
      this.clearRelatedFields()
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    assignDocNo(item) {
      this.form.docNo = item.docNo
      this.form.name = item.name
      this.form.currency = item.curr
      this.form.amount = this.formatDisplayNumber(item.paytAmt)
      this.showUnRelClmDocHelpList = false
    },
    assignBaseCurr(data) {
      this.form.currency = data[0]
    },
    openDocNoModal() {
      this.showUnRelClmDocHelpList = true
    },
    getDesc(obj) {
      return obj.label !== undefined ? obj.label : ''
    }
  },
  computed: {
    menu() {
      return this.$store.state.clmUnrelDel.menu
    },
    init() {
      return this.$store.state.commons.init
    }
  },
  watch: {
    init: function (value) {
      this.doInit()
    },
    'form.branch': function () {
      this.updateDocNoList()
    },
    'form.fund': function () {
      this.updateDocNoList()
    },
    'form.tranType1': function () {
      this.updateDocNoList()
    },
    amountcurrencies: function () {
      this.form.currency = this.getDesc(this.getItemValue(this.form.currency, this.amountcurrencies))
    }
  },
  mixins: [claimUnrelDelMixin, MessageMixin, commonAjaxMixin],
  components: {
    UnRelClmDocHelpList
  }
}
</script>
<style lang="scss">
</style>
